import { ImageGenNewSettingsDimensionOptionTypes } from 'src/types/settings';

export const ImageSettingsPrimaryGroup: Record<
  string,
  {
    title: string;
    resolution: string;
  }
> = {
  [ImageGenNewSettingsDimensionOptionTypes.SQUARE]: {
    title: 'Square',
    resolution: '1024x1024',
  },
  [ImageGenNewSettingsDimensionOptionTypes.PORTRAIT]: {
    title: 'Portrait',
    resolution: '1024x1536',
  },
  [ImageGenNewSettingsDimensionOptionTypes.LANDSCAPE]: {
    title: 'Landscape',
    resolution: '1536x1024',
  },
};
